// extracted by mini-css-extract-plugin
export default {"container":"paymentTypeName_container__5UL1X","badge":"paymentTypeName_badge__07sE8"};